function toTwoDecimals (value) {
  const num = typeof value === 'string' ? parseFloat(value) : value
  if (!Number.isFinite(num)) return 0
  return Math.round(num * 100) / 100
}

export { toTwoDecimals }
